export default "__VITE_ASSET__yuuD8usQ__"